exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".attribute-form[data-v-403612bb] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  flex-direction: column;\n}\n.attribute-form__possible-values[data-v-403612bb] {\n  padding: 10px 0;\n}\n.attribute-form__possible-value[data-v-403612bb] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 10px;\n}\n.attribute-form__btns[data-v-403612bb] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  justify-content: flex-end;\n}", ""]);

// exports
